import React, { useState, useEffect } from "react"
import API from "../../api"
import Button from "components/button"
import { Collapse, Modal, Input } from "antd"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "store/store"
import { X } from "react-feather"
import TextInputField from "components/textInput"
import { useNavigate } from "react-router-dom"
import { ROUTES } from "routes"
import { getServiceName } from "constants/service/service"
import { isGlovv } from "constants/domains/domains"

const LectureIndex: React.FC = (props: any) => {
  const [lectures, setLectures] = useState([])
  const [activeKey, setActiveKey] = useState<string | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isEnterModalOpen, setIsEnterModalOpen] = useState(false)
  const [selectedLecture, setSelectedLecture] = useState(null)
  const [password, setPassword] = useState("")
  const [isPasswordWrong, setIsPasswordWrong] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const fetchLectures = async () => {
      try {
        const response = await API.Lecture.index()
        setLectures(response.data.lectures)
      } catch (error) {
        console.error("강의 목록을 불러오는 중 오류가 발생했습니다:", error)
      }
    }

    fetchLectures()
  }, [])

  const handlePreviewClick = (lectureId: string) => {
    setActiveKey(activeKey === lectureId ? null : lectureId)
  }

  const handleModalOpen = (lecture: any) => {
    setSelectedLecture(lecture)
    setIsModalOpen(true)
    window.scrollTo(0, 0)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const handleEnterModalOpen = () => {
    setIsEnterModalOpen(true)
    window.scrollTo(0, 0)
  }

  const handleEnterModalClose = () => {
    setIsEnterModalOpen(false)
  }

  return (
    <div className="min-h-screen p-8">
      <div className="absolute inset-0 bg-gradient-to-b from-pink-100 via-pink-50 to-transparent z-[-1] h-[300px]"></div>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">
          <span className="bg-gradient-to-r from-[#5E60EF] via-[#FF0099] to-[#FF4500] text-transparent bg-clip-text">
            200만원 상당의
          </span>
          <br />
          <span className="bg-gradient-to-r from-[#5E60EF] via-[#FF0099] to-[#FF4500] text-transparent bg-clip-text">
            온라인 마케팅 강의를 무료로 공개합니다
          </span>
        </h1>

        <div className="flex justify-between mb-12">
          <div className="text-center">
            <p className="text-[3.4375rem]">✨</p>
            <p className="text-[1.375rem] font-bold">
              브랜드에
              <br />
              최적화된 마케팅
            </p>
          </div>
          <div className="text-center">
            <p className="text-[3.4375rem]">📱</p>
            <p className="text-[1.375rem] font-bold">
              인스타그램 광고
              <br />
              만들기부터
            </p>
          </div>
          <div className="text-center">
            <p className="text-[3.4375rem]">📸</p>
            <p className="text-[1.375rem] font-bold">
              {getServiceName()} 컨텐츠
              <br />
              2차 활용 방법까지
            </p>
          </div>
        </div>

        <div className="mt-12">
          {lectures.length > 0 ? (
            <ul className="space-y-4">
              {lectures
                .sort((a, b) => (b.isReleased ? 1 : -1) - (a.isReleased ? 1 : -1))
                .map((lecture) => (
                  <li key={lecture.id} className="bg-white rounded-lg p-4 shadow-md">
                    <Collapse
                      activeKey={activeKey}
                      ghost={true}
                      bordered={false}
                      className="border-none [&_.ant-collapse-header]:p-0"
                    >
                      <Collapse.Panel
                        key={lecture.id}
                        showArrow={false}
                        header={
                          <div className="flex items-center justify-between bg-white p-4 w-full cursor-default">
                            <div className="flex flex-row">
                              <img src={lecture.icon} alt={lecture.title} className="h-8 mr-4" />
                              <div className="flex flex-col">
                                <span className="font-bold text-[1.375rem]">{lecture.title}</span>
                                <span className="text-[0.8125rem] text-[#999999]">{lecture.description}</span>
                              </div>
                            </div>

                            <div className="flex space-x-2 items-center">
                              {lecture.isReleased ? (
                                <>
                                  {lecture.preview ? (
                                    <div className="w-[200px]">
                                      <Button
                                        text="강의 첫 화 미리보기"
                                        textColor={"black"}
                                        borderColor={"transparent"}
                                        textClassName="text-[0.9375rem] underline mr-2"
                                        className="flex justify-end"
                                        onClick={() => handlePreviewClick(lecture.id)}
                                      />
                                    </div>
                                  ) : null}

                                  <div className="w-[200px]">
                                    <Button
                                      text="강의실 무료 입장하기"
                                      textColor={"white"}
                                      borderColor={"transparent"}
                                      textClassName="font-bold text-[0.9375rem]"
                                      className="flex bg-black px-4 rounded py-[15px] justify-center w-full"
                                      onClick={() => handleModalOpen(lecture)}
                                    />
                                  </div>
                                </>
                              ) : (
                                <div className="w-[200px]">
                                  <Button
                                    text="준비중"
                                    textColor={"white"}
                                    borderColor={"transparent"}
                                    textClassName="font-bold text-[0.9375rem]"
                                    className="flex bg-gray-200 px-4 rounded py-[15px] justify-center w-full"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        }
                      >
                        <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
                          <iframe
                            src={lecture.preview}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                            style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }}
                            title={lecture.title}
                          />
                        </div>
                      </Collapse.Panel>
                    </Collapse>
                  </li>
                ))}
            </ul>
          ) : (
            <></>
          )}
        </div>
      </div>
      <LectureModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        handleEnterModalOpen={handleEnterModalOpen}
        preferences={props.preferences}
        settings={props.settings}
        password={password}
        setPassword={setPassword}
        isPasswordWrong={isPasswordWrong}
        setIsPasswordWrong={setIsPasswordWrong}
        setPreferences={props.setPreferences}
        navigate={navigate}
      />
      <EnterModal
        isOpen={isEnterModalOpen}
        onClose={handleEnterModalClose}
        preferences={props.preferences}
        setPreferences={props.setPreferences}
        showModal={props.showModal}
        lecture={selectedLecture}
        password={password}
        navigate={navigate}
        auth={props.auth}
      />
    </div>
  )
}

const LectureModal = ({
  isOpen,
  onClose,
  preferences,
  settings,
  handleEnterModalOpen,
  password,
  setPassword,
  isPasswordWrong,
  setIsPasswordWrong,
  setPreferences,
  navigate,
}) => {
  const mobileContainerClassName = "flex flex-col bg-white py-10 px-5 overflow-scroll min-w-[100vw] w-full"
  const desktopContainerClassName = "flex flex-col bg-white rounded-2xl overflow-visible w-[480px] px-10 py-10 w-full"

  const [containerClassName, setContainerClassname] = useState(
    preferences.isMobile ? mobileContainerClassName : desktopContainerClassName
  )

  useEffect(() => {
    setContainerClassname(preferences.isMobile ? mobileContainerClassName : desktopContainerClassName)
  }, [preferences.isMobile])

  const handleConfirm = async () => {
    try {
      const response = await API.Lecture.password({
        domain: isGlovv() ? 'glovv' : 'oneulook',
        password
      })
      if (response.code === 200) {
        setIsPasswordWrong(false)

        const lectureUser = {
          ...preferences.lectureUser,
          password,
        }

        setPreferences({ lectureUser })
        onClose()
        await new Promise((resolve) => setTimeout(resolve, 500))
        handleEnterModalOpen()
      }
    } catch (error) {
      setIsPasswordWrong(true)
      setPassword("")
    }
  }

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      className={preferences.isMobile ? "squared-antd-modal" : "rounded-antd-modal"}
      closeIcon={null}
    >
      <div className={containerClassName}>
        <div className="flex flex-row justify-between">
          {isPasswordWrong == false ? (
            <span className="font-bold text-xl tracking-tighter">강의실 무료 입장하기</span>
          ) : (
            <span className="font-bold text-xl tracking-tighter">무료 입장코드가 틀렸습니다</span>
          )}
          <span className="text-sm tracking-tighter underline cursor-pointer" onClick={onClose}>
            <X />
          </span>
        </div>
        <div className="flex flex-col">
          {isPasswordWrong == false ? (
            <span className="font-bold text-[2rem] tracking-tighter line-through text-black py-[50px] text-center">
              정가 2,200,000원
            </span>
          ) : (
            <span className="font-bold text-[1.375rem] tracking-tighter text-black py-[50px]">
              무료 입장코드는 주기적으로 바뀌며 <br />
              {getServiceName()} 카카오톡 오픈 채팅방에서 확인이 가능합니다.
            </span>
          )}

          <TextInputField
            bordered
            placeholder="무료 입장코드"
            className="mb-5"
            value={password}
            onChangeText={(value: string) => {
              setPassword(value)
            }}
          />

          <Button
            text="확인"
            textColor={"white"}
            buttonColor={password && password.length ? "black" : "#C8C8C8"}
            borderColor={"transparent"}
            textClassName="font-bold text-sm tracking-tighter"
            className="flex bg-black px-4 rounded py-[15px] justify-center w-full mb-5"
            onClick={handleConfirm}
          />

          <div className="flex flex-col bg-[#EFEFFC] border border-[#000000] py-[30px] px-[20px] items-center gap-[10px]">
            <p className="text-[#000000] font-bold text-[22px]">무료 입장코드 확인하는 방법</p>

            <span className="tracking-tighter text-center text-[0.9375rem] text-[#000000]">
              아래 카카오톡 오픈 채팅방에 들어오시면
              <br />
              바로 확인하실 수 있습니다.
            </span>

            <Button
              text="오픈 채팅방 입장하기"
              textColor={"white"}
              buttonColor={"#000000"}
              borderColor={"#000000"}
              textClassName="font-bold text-[0.9375rem]"
              className="flex bg-white px-4 rounded py-[15px] justify-center w-full mt-[5px]"
              onClick={() => {
                const url = isGlovv() ? settings.lectureChatroomUrlGlovv : settings.lectureChatroomUrl
                window.open(url, "_blank")
              }}
            />

            <span className="tracking-tighter text-center text-[0.9375rem] font-bold text-[#000000]">
              {`* 채팅방 비밀번호 : ${isGlovv() ? 'glovv' : 'oneulook'}`}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  )
}

const EnterModal = ({ isOpen, onClose, preferences, setPreferences, lecture, showModal, password, navigate, auth }) => {
  const mobileContainerClassName = "flex flex-col bg-white py-10 px-5 overflow-scroll min-w-[100vw] w-full"
  const desktopContainerClassName = "flex flex-col bg-white rounded-2xl overflow-visible w-[480px] px-10 py-10 w-full"

  const [containerClassName, setContainerClassname] = useState(
    preferences.isMobile ? mobileContainerClassName : desktopContainerClassName
  )

  const [name, setName] = useState(preferences?.lectureUser?.name)
  const [phoneNumber, setPhoneNumber] = useState(preferences?.lectureUser?.mobile ?? "010")

  useEffect(() => {
    setContainerClassname(preferences.isMobile ? mobileContainerClassName : desktopContainerClassName)
  }, [preferences.isMobile])

  const handleEnter = async () => {
    try {
      const sanitizedPhoneNumber = phoneNumber.replace(/[^0-9]/g, "")

      const response = await API.Lecture.storeWatchHistory({
        brandToken: auth.token,
        lecture_id: lecture.id,
        mobile: sanitizedPhoneNumber,
        name: name,
      })

      onClose()
      navigate(ROUTES.LECTURE_LESSON_INDEX.SHOW(lecture.id))

      const lectureUser = {
        ...preferences.lectureUser,
        password: password,
        name: name,
        mobile: sanitizedPhoneNumber,
      }

      setPreferences({ lectureUser })

      setPreferences({
        ...preferences,
        lectureUser,
      })
    } catch (error) {
      if (error.data && error.data.errors) {
        const errorMessages = Object.values(error.data.errors).flat().join("\n")
        showModal({ text: `강의 시청 기록 저장 중 오류 발생\n${errorMessages}` })
      } else {
        showModal({ text: `강의 시청 기록 저장 중 오류 발생\n${error.message}` })
      }
    }
  }

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      className={preferences.isMobile ? "squared-antd-modal" : "rounded-antd-modal"}
      closeIcon={null}
    >
      <div className={containerClassName}>
        <div className="flex flex-row justify-between mb-6">
          <span className="font-bold text-xl tracking-tighter">강의실 무료 입장하기</span>
          <span className="text-sm tracking-tighter underline cursor-pointer" onClick={onClose}>
            <X />
          </span>
        </div>
        <div className="flex flex-col space-y-4">
          <span className="text-[0.9375rem] tracking-tighter mb-[30px]">
            {getServiceName()} 오픈 채팅방 멤버인지 확인하는 단계입니다.
          </span>

          <TextInputField bordered placeholder="이름" value={name} onChangeText={setName} />
          <TextInputField bordered placeholder="휴대폰" value={phoneNumber} onChangeText={setPhoneNumber} />
          <Button
            text="입장하기"
            textColor={"white"}
            buttonColor={name && phoneNumber ? "black" : "#C8C8C8"}
            borderColor={"transparent"}
            textClassName="font-bold text-sm tracking-tighter"
            className="flex bg-black px-4 rounded py-[15px] justify-center w-full"
            onClick={handleEnter}
          />
        </div>
      </div>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(LectureIndex)
